import { c as _c } from "react/compiler-runtime";
import { getOrgAgentsInfiniteOptions } from '@onefootprint/fetch-dashboard';
import type { AgentResponse } from '@onefootprint/request-types/dashboard';
import { useInfiniteQuery } from '@tanstack/react-query';
const PAGE_SIZE = 25;
const useAvailableAgents = () => {
  const $ = _c(10);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getOrgAgentsInfiniteOptions({
      query: {
        pageSize: PAGE_SIZE
      }
    });
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...t0,
      enabled: true,
      initialPageParam: {
        query: {
          pageSize: PAGE_SIZE
        }
      },
      getNextPageParam: _temp
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const query = useInfiniteQuery(t1);
  let t2;
  if ($[2] !== query.data?.pages) {
    t2 = query.data?.pages.flatMap(_temp2) ?? [];
    $[2] = query.data?.pages;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const items = t2;
  const t3 = !!query.hasNextPage;
  let t4;
  if ($[4] !== items || $[5] !== query.fetchNextPage || $[6] !== query.isFetchingNextPage || $[7] !== query.isLoading || $[8] !== t3) {
    t4 = {
      items,
      isLoading: query.isLoading,
      isFetchingNextPage: query.isFetchingNextPage,
      hasNextPage: t3,
      fetchNextPage: query.fetchNextPage
    };
    $[4] = items;
    $[5] = query.fetchNextPage;
    $[6] = query.isFetchingNextPage;
    $[7] = query.isLoading;
    $[8] = t3;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
export default useAvailableAgents;
function _temp(lastPage) {
  return lastPage.meta.next ?? undefined;
}
function _temp2(p) {
  return p.data;
}